export default {
  servers: {
    title: 'Серверы'
  },
  events: {
    title: 'Последние события'
  },
  db_status: {
    title: 'Статус базы данных'
  }
}
